module.exports = __webpack_public_path__ + "img/HSTutorial.f4f0720d.png";